import { buildApiUrl } from '../../services/apiConfig';

class QueryDataService {
  async request(endpoint, options = {}) {
    const token = localStorage.getItem('auth_token') || 'dev-token';
    const response = await fetch(buildApiUrl('NOVA_INGESTION', endpoint), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers,
      },
      ...options,
    });
    if (!response.ok) {
      throw new Error(`API error ${response.status}: ${await response.text()}`);
    }
    return response.json();
  }

  async getSources() {
    return this.request('/sources');
  }

  async textToSQL(question, sourceId) {
    return this.request('/text-to-sql/query', {
      method: 'POST',
      body: JSON.stringify({ question, source_id: sourceId }),
    });
  }

  async textToSQLStream(params, onEvent, signal) {
    const token = localStorage.getItem('auth_token') || 'dev-token';
    const response = await fetch(buildApiUrl('NOVA_INGESTION', '/text-to-sql/stream'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(params),
      signal,
    });

    if (!response.ok) {
      throw new Error(`API error ${response.status}: ${await response.text()}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop(); // hold incomplete last line for next chunk
      for (const line of lines) {
        if (!line.startsWith('data: ')) continue;
        try {
          onEvent(JSON.parse(line.slice(6)));
        } catch { /* skip malformed */ }
      }
    }

    // flush any remaining data after stream closes
    if (buffer.startsWith('data: ')) {
      try {
        onEvent(JSON.parse(buffer.slice(6)));
      } catch { /* skip malformed */ }
    }
  }

  async executeSQL(sql, sourceId) {
    return this.request('/text-to-sql/query', {
      method: 'POST',
      body: JSON.stringify({ question: sql, source_id: sourceId }),
    });
  }

  async getQueryHistory(limit = 20) {
    return this.request(`/text-to-sql/audit?limit=${limit}`);
  }
}

export default new QueryDataService();
